import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-xhr-backend";
const win: any = window;

const allowedLanguages = ["en", "ar"];
let lng: string | undefined = win["lang"] == null ? "en" : win["lang"];
// window.lang == null ? 'en':window.lang
// let lng = 'ar';
// console.log(lng);

const storageLanguage = localStorage.getItem("language");
if (storageLanguage && allowedLanguages.indexOf(storageLanguage) > -1) {
  lng = win["lang"];
}

i18n
  .use(XHR)
  .use(initReactI18next)
  .init({
    lng,
    debug: true,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      // loadPath: '/translations/{{lng}}.json',
      loadPath: 
        "/.contact.us/mobily-contact-us-react/build/translations/{{lng}}.json",
      allowMultiLoading: true,
    },
    react: {
      wait: true,
      useSuspense: true,
    },
  });

export default i18n;
